 import Auth, {COMPANY_OWNER, COMPANY_MANAGER} from '../../../lib/users/auth';
import {BigPill, SmallPill} from '../../../components/pills';
import {PasswordButton, UploadButton, DeleteButton, SendButton} from '../../../components/buttons';
import CompaniesApi from '../../../lib/companies/companies-api';

import AlertManager from '../../../managers/alert/alert-manager';
import React from "react";

import Input from '../../../components/input-with-label';
import TeamMember from '../../../components/team-member';
import Dropdown from '../../../components/dropdowns/dropdown';
import Checkbox from '../../../components/checkbox';

import Section from './account-section';

import ManageStaff from '../components/account-company-manage-staff';
import RemoveStaff from '../components/account-company-remove-staff';
import {stringToFriendlyDatetime} from "../../../lib/helpers/datetime-helpers";
import UsersApi from "../../../lib/users/users-api";

import CompanyTypes from '../../../components/company-types';

const AdminView = ({company, industries = [], onChange, getError }) => {

    const profile = company.company_profile?.profile || {};

    const types = [
        {
            type: 'Company Email Address',
            name: 'email',
            value: profile.email,
        },
        {
            type: 'Telephone Number',
            name: 'tel_no',
            value: profile.tel_no
        },
        {
            type: 'Business Address Line 1',
            name: 'address_one',
            value: profile.address_one
        },
        {
            type: 'Business Address Line 2',
            name: 'address_two',
            value: profile.address_two
        },
        {
            type: 'Business Address City',
            name: 'address_city',
            value: profile.address_city
        },
        {
            type: 'Business Address Post Code',
            name: 'address_post_code',
            value: profile.address_post_code
        }
    ]

    const handleProfileChange = (e) => {
        let updated = {...profile};
        updated[e.target.name] = e.target.value;
        let companyProfile = {...company.company_profile};
        companyProfile.profile = updated;

        onChange('company_profile', companyProfile);
    }

    const handleCompanyChange = (e) => {
        let updated = Object.assign({ ...profile }, e);
        let companyProfile = {...company.company_profile};
        companyProfile.profile = updated;

        onChange('company_profile', companyProfile);

    }


    const selectedIndustry = industries.find(i => i.id === company.company_industry_id);

    return (
        <div className="information__outer">
            <Input value={company.name} onChange={e => onChange('name', e.target.value)}
                   placeholder="Enter company name" label="Company Name" errors={getError('name')}/>
            <div className='information__row'>
                { industries.length > 0 && <Dropdown label="Select your industry" value={selectedIndustry ? {value: selectedIndustry.id, label : selectedIndustry.name} : null } items={industries.map(val => ({
                    label: val.name,
                    value: val.id,
                }))} onChange={e => onChange('company_industry_id', e.value)}/> }

                <div className="information">
                    <p className="information__label">Joined myEB</p>
                    <p className="information__text">{stringToFriendlyDatetime(company.created_at)}</p>
                </div>
            </div>

            <CompanyTypes values={profile} company_types={profile.company_type}
                handleChange={e => handleCompanyChange(e)}
                onCheckboxTypeChange={(e) => handleCompanyChange({ company_type: e.option, company_number: '', company_number_type: '' })}/>

            <div className='information__row'>
                <Dropdown
                    label={'Number of employees'}
                    placeholder='Please select number of employees'
                    items={[
                        { label: '1-10', value: '1-10' },
                        { label: '11-50', value: '11-50' },
                        { label: '51-150', value: '51-150' },
                        { label: '151-250', value: '151-250' },
                        { label: '251+', value: '251+' }
                  ]}
                value={profile.number_of_employees_range}
                onChange={value => {
                    handleProfileChange({target:  { name : 'number_of_employees_range', value : value.value} })
                }}/>
            </div>

            { _.chunk(types, 2).map(chunk => {
                return (
                    <div className='information__row'>
                        { chunk.map(type => {

                            return <Input value={profile[type.name] ? profile[type.name] : '' } name={type.name}
                            onChange={e => handleProfileChange(e)} placeholder="Input Value"
                            label={type.type}/>
                        })}
                    </div>
                )
            })}
        </div>
    )
}

const UserView = ({company, industries}) => {
    return (
        <div className="information__outer">
            <div className="information">
                <p className="information__label">Company Name</p>
                <p className="information__text">{company.name}</p>
            </div>
            <div className="information__row">
                <div className="information">
                    <p className="information__label">Industry</p>
                    <p className="information__text">{ industries.find(i => i.id === company.company_industry_id) ? industries.find(i => i.id === company.company_industry_id).name : ''}</p>
                </div>
                <div className="information">
                    <p className="information__label">Joined myEB</p>
                    <p className="information__text">{stringToFriendlyDatetime(company.created_at)}</p>
                </div>
            </div>
        </div>
    )
}

export default class AccountCompany extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            manageStaff: false,
            removeStaff: false,
            loaded: false,
            company: {},
            industries: [],
            users : [],
            managedUser : {},
            roles : [],
            userInvites : [],
            user_email_invite : '',
            user_invite_role : null,
            inviteErrors : {}
        }
    }


    componentDidMount() {
        this.getCompany();
        this.getIndustries();
        this.getUsers();
        this.getRoles();
        this.getUserInvites();
        this.props.onSaveSet(this.handleSave.bind(this));

    }

    handleErrors = (e) => {
        Object.keys(e).forEach(key => {
            this.props.addError(true, e[key], key);
        });
    }

    handleSave() {
        CompaniesApi.update(this.state.company.id, this.state.company, this.handleErrors).then(() => {
            CompaniesApi.updateProfile(this.state.company.id, this.state.company.company_profile, this.handleErrors).then(() => {
                AlertManager.success('Details updated');
                this.props.setValidation([]);
            });
        });
    }

    getRoles() {
        UsersApi.roles(1, 100).then(data => {
            this.setState({roles : data.data});
        })
    }

    getUsers() {
        CompaniesApi.users(Auth.user.company_id, 1, 150).then(data => {
            this.setState({users : data.data});
        });
    }

    getCompany() {
        CompaniesApi.getCompany(Auth.user.company_id).then(data => {
            this.setState({company: data, loaded : true})
        });
    }

    getIndustries() {
        CompaniesApi.getIndustries().then(({ data }) => {
            this.setState({ industries: data })
        })
    }

    getUserInvites() {
        CompaniesApi.userInvites(Auth.user.company_id, 1, 100).then(response => {
            this.setState({
                userInvites : response.data
            });
        })
    }

    handleCompanyChange(name, value) {
        this.setState({
            company: Object.assign({}, this.state.company, {
                [name]: value
            })
        });
    }

    handleUserInvite() {
        CompaniesApi.inviteUser(Auth.user.company_id, this.state.user_email_invite, [this.state.user_invite_role], errors => {
            this.setState({inviteErrors : errors}, () => console.log(this.state, errors))
        }).then(() => {
            this.setState({
                user_email_invite : null,
                user_invite_role : null
            });
            this.getUserInvites()
        });
    }

    getRoleById(id) {
        const  role = this.state.roles.find(item => item.id === id);

        return role;
    }

    render() {
        const admin = Auth.hasOneOfPermissions([COMPANY_OWNER, COMPANY_MANAGER]);

        return (
            <>

                {this.state.manageStaff === true && <ManageStaff roles={this.state.roles} user={this.state.managedUser} setPopup={() => {
                    this.getUsers();
                    this.setState({manageStaff: false, managedUser: {}})
                }}/>}
                {this.state.removeStaff === true && <RemoveStaff user={this.state.managedUser} setPopup={() => this.setState({removeStaff: false, managedUser: {}})}/>}

                <div class="account__companies">
                    <Section title="Overview" className="account__top">
                        {this.state.loaded &&
                        <div className="account-section__left">
                            {admin ? <AdminView
                                    getError={this.props.getError}
                                    industries={this.state.industries}
                                    company={this.state.company}
                                    onChange={this.handleCompanyChange.bind(this)}/> :
                                <UserView company={this.state.company} industries={this.state.industries}/>}
                        </div>
                        }

                        <div className="account-section__right"></div>
                    </Section>

                    {
                        this.state.users.length >= 1 &&
                        <Section title="My team">
                            <div className="account-companies__grid">
                                {this.state.users.map((user, index) => {
                                    return(
                                        <TeamMember key={index} data={user} adminView={admin}
                                                    onManage={() => this.setState({manageStaff: true, managedUser : user})}
                                                    onRemove={() => this.setState({removeStaff: true,  managedUser : user})}/>
                                    );
                                })}


                            </div>
                        </Section>
                    }


                    {admin &&
                    <Section title="Invite Staff">
                        <div className="information__outer">
                            <div className="information__row">
                                <Input errors={this.state.inviteErrors.email} placeholder="Input Value" type={'email'} label="Team member email address" value={this.state.user_email_invite} onChange={e => this.setState({ user_email_invite : e.target.value})} />
                                <div className="information">
                                    <p className="information__label">What is their role in the company</p>
                                    <div className='utils__row utils__gap--20'>
                                        {
                                            this.state.roles.map((role, index) => {
                                                return(
                                                    <Checkbox checked={this.state.user_invite_role === role.id} key={index} onChange={() => this.setState({user_invite_role : role.id })} text={role.name} />
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="information">
                                    <p></p>
                                    <SendButton disabled={!this.state.user_invite_role || !this.state.user_email_invite} onClick={this.handleUserInvite.bind(this)}/>

                                </div>
                            </div>

                            {
                                this.state.userInvites.length >= 1 &&
                                <div className="information">
                                    <p className="information__label">Invites Sent (pending response)</p>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Email</th>
                                                <th>Role</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.userInvites.map((item, index) => {
                                                const role = this.getRoleById(item.role_ids[0]);
                                                return(
                                                    <tr key={index}>
                                                        <th>{item.email}</th>
                                                        <th>{role ? role.name : ''}</th>
                                                    </tr>
                                                );
                                            })
                                        }
                                        </tbody>


                                    </table>
                                </div>
                            }

                        </div>
                    </Section>
                    }
                </div>
            </>
        )
    }


}
